import { render } from "./IconPrinter.vue?vue&type=template&id=1dd11b40"
import script from "./IconPrinter.vue?vue&type=script&lang=js"
export * from "./IconPrinter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__